var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 37.5H33.25",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 41.5H33.25",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.5V4.5H37.75V14.5M15.75 14.5H7.25C6.14543 14.5 5.25 15.3954 5.25 16.5V35C5.25 36.1046 6.14543 37 7.25 37H14.75M15.75 14.5H37.75M37.75 14.5H46.75C47.8546 14.5 48.75 15.3954 48.75 16.5V35C48.75 36.1046 47.8546 37 46.75 37H38.75M38.75 37L39.25 49.5H14.25L14.75 37M38.75 37V31H14.75V37",
    stroke: "black",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.75,
    y: 19,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.138270c0f4f1b813a53a4677f5b048a9.svg";
export { ForwardRef as ReactComponent };